<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="400px"
    append-to-body
    :close-on-click-modal="false"
  >
    <div>
      <el-form label-position="left" label-width="70px">

        <div v-if="type === 0">
          <span style="font-size: 18px;">{{ $t('CargoMsg.Cargo_AllocationCancel') }}</span>
          <br>
          <el-checkbox v-model="cancelCabin" style="padding-top: 20px;padding-bottom: 20px" no="cancelCabin">{{ $t('CargoMsg.Cargo_CabinReturn') }}</el-checkbox>
        </div>

        <el-form-item v-if="type === 1 || cancelCabin" :label="$t('CargoMsg.Cargo_CabinCancellationExplanation')">
          <el-input
            v-model="note"
            no="note"
            type="textarea"
            :rows="10"
            style="width: 285px;"
          />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button no="confirm" type="primary" @click="enterHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { allocationFunc, checkJobCancelCabinFunc } from '@/api/booking/cabinManagement'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'CancelCabinWindow',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    list: { type: Array, required: true },
    type: { type: Number, required: false, default: 0 },
    cabinType: { type: Boolean, required: false },
    title: { type: String, required: false, default: '' }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      fullscreenLoading: false,
      note: '',
      cancelCabin: false
    }
  },
  computed: {},
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (!this.innerVisible) {
        this.note = ''
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.note = ''
      this.innerVisible = true
    }
  },
  methods: {
    enterHandler() {
      // 退舱
      if (this.type === 1) {
        if (!this.note) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CabinReturnTip'))
          return
        }
        const uuidList = this.list.map(bm => bm.uuid)
        allocationFunc({ type: 3, uuidList: uuidList, cancelCabinRemark: this.note }).then(res => {
          this.$emit('confirmSync')
          this.$message.success(this.$t('CargoMsg.Cargo_CancelCabinTip2'))
          this.innerVisible = false
        })
      }
      // 撤销分配
      if (this.type === 0) {
        if (this.cancelCabin && !this.note) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CabinReturnTip'))
          return
        }
        const jobUuids = this.list.map(bm => bm.jobUuid)
        checkJobCancelCabinFunc({ uuidList: jobUuids }).then(res => {
          const { audit, operation } = res.data
          if (audit) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CancelCabinTip4'))
            return
          }
          if (operation) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CancelCabinTip5'))
            return
          }
          const uuidList = this.list.map(bm => bm.uuid)
          allocationFunc({ type: 2, uuidList: uuidList, cancelCabinRemark: this.note, cancelCabin: this.cancelCabin }).then(res => {
            this.$emit('confirmSync')
            JobUtils.createSuccessHandler(this, res, this.cabinType)
            this.innerVisible = false
          })
        })
      }
    },
    close() {
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
